function consistencySuffix(typology) {
  switch (typology) {
    case 'A':
      return 'm2';
    case 'B':
      return 'm3';
    case 'C':
      return 'm2';
    default:
      return 'm2';
  }
}

export const cadastreUrbanFields = (data) => {
  return [
    {
      name: 'section_code',
      type: 'string',
      required: false,
      size: 'ms-sm3',
    },
    {
      name: 'map_sheet_number',
      type: 'string',
      required: true,
      size: 'ms-sm3',
    },
    {
      name: 'parcel_number',
      type: 'string',
      required: true,
      size: 'ms-sm3',
    },
    {
      name: 'subparcel_number',
      type: 'string',
      required: false,
      size: 'ms-sm3',
    },
    {
      name: 'typology',
      type: 'string',
      required: true,
      size: 'ms-sm3',
    },
    {
      name: 'class_of_productivity',
      type: 'string',
      required: true,
      size: 'ms-sm3',
    },
    {
      name: 'rooms',
      type: 'number',
      // required: true,
      // suffix:
      //   data && data.typology ? consistencySuffix(data.typology) : undefined,
      visible: data && (data.typology === 'A' || !data.typology),
      size: 'ms-sm3',
    },
    {
      name: 'cadastral_income',
      type: 'currency',
      required: true,
      size: 'ms-sm3',
    },
    {
      name: 'size',
      type: 'number',
      required: true,
      suffix:
        data && data.typology ? consistencySuffix(data.typology) : undefined,
      visible: true,
      size: 'ms-sm3',
    },
    {
      name: 'size_netto',
      type: 'number',
      required: true,
      suffix:
        data && data.typology ? consistencySuffix(data.typology) : undefined,
      visible: data && (data.typology === 'A' || !data.typology),
      size: 'ms-sm9',
    },
    {
      name: 'cadastral_municipality',
      type: 'string',
      required: false,
      size: 'ms-sm4',
    },
    {
      name: 'address',
      type: 'string',
      required: false,
      size: 'ms-sm8',
    },
  ].filter((f) => f.visible !== false);
};

export const cadastreUrbanProps = () => {
  const result = {};

  cadastreUrbanFields(null).forEach((field) => {
    result[field.name] = field.type === 'string' ? '' : 0;
  });

  return result;
};



// WEBPACK FOOTER //
// ./src/app/@propnow/containers/Sale/SaleEditSection/_it/cadastreFields/cadastreUrbanFields.js